import {
  ApertureIcon, ContrastIcon, CropIcon, DropletsIcon, FlipIcon, FrameIcon, SearchIcon, SunMediumIcon, TypeIcon,
  WandIcon, XIcon,
} from '../ProductFrameIcons'

/**
 * The Artboard tool catalogue, opened from the rail's Image button. Layout follows
 * genie-studio-ui canvas-toolbar.tsx: a panel beside the rail with a "Tools" header
 * and close button, "Search all tools…", then sections titled "Category · Group"
 * with full-width rows. Rows and their order are what artToolItems() builds from
 * the 60 built-in apps (apollo engine/canvas-app-catalog.mjs), scrolled to Image;
 * icons are the app's own (apollo src/lib/app-icons.ts).
 */
const SECTIONS = [
  {
    label: 'Image · Empty frames',
    rows: ['1:1', '4:5', '2:3', '16:9', '9:16', '3:2'].map((label) => ({ label, Icon: FrameIcon })),
  },
  {
    label: 'Image · Edit & style',
    rows: [
      { label: 'Color & light', Icon: SunMediumIcon },
      { label: 'Blur', Icon: DropletsIcon },
      { label: 'Sharpen', Icon: ApertureIcon },
      { label: 'Black & white', Icon: ContrastIcon },
      { label: 'Crop', Icon: CropIcon },
      { label: 'Flip & rotate', Icon: FlipIcon },
      { label: 'Text overlay', Icon: TypeIcon },
      { label: 'Edit image', Icon: WandIcon },
    ],
  },
] as const

export function ToolsMenu() {
  return (
    <section className="absolute top-3 bottom-3 left-[64px] z-20 flex w-[224px] flex-col overflow-hidden rounded-xl border border-line bg-card shadow-[0_2px_8px_rgba(2,2,2,0.06)]">
      <div className="flex items-center justify-between px-3 pt-2 pb-1">
        <h2 className="text-[12px] font-medium text-bone">Tools</h2>
        <XIcon width={12} height={12} className="text-muted" />
      </div>
      <div className="mx-3 mt-1 mb-2 flex items-center gap-2 rounded-lg bg-panel px-2.5 py-1.5 text-[11px] text-faint">
        <SearchIcon width={12} height={12} />
        Search all tools…
      </div>
      <div className="min-h-0 flex-1 overflow-hidden px-3">
        {SECTIONS.map((section) => (
          <div key={section.label} className="pt-2.5 first:pt-1">
            <h3 className="mb-1.5 text-[10px] font-medium text-muted">{section.label}</h3>
            <div className="flex flex-col gap-1">
              {section.rows.map(({ label, Icon }) => (
                <span key={label} className="flex min-h-7 items-center gap-2 rounded-lg bg-panel/50 px-2 py-1.5 text-[11px] text-bone">
                  <Icon width={13} height={13} />
                  {label}
                </span>
              ))}
            </div>
          </div>
        ))}
      </div>
    </section>
  )
}
